export const shouldHandoffExistingSession = (params: {
  hasUser: boolean;
  mobileRedirect: string | null;
  autoLoginAttempted: boolean;
  recentHandoff: boolean;
  forceReauth?: boolean;
}): boolean => {
  if (params.forceReauth) return false;
  if (!params.hasUser || !params.mobileRedirect) return false;
  if (params.autoLoginAttempted || params.recentHandoff) return false;
  return true;
};

export const shouldAttemptRememberedAutoLogin = (params: {
  authLoading: boolean;
  hasUser: boolean;
  showReset: boolean;
  autoLoginAttempted: boolean;
  recentHandoff: boolean;
}): boolean => {
  if (params.authLoading || params.hasUser || params.showReset) return false;
  if (params.autoLoginAttempted || params.recentHandoff) return false;
  return true;
};
